"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _pclnDesignSystem = require("pcln-design-system");

var _HotelInfo = _interopRequireDefault(require("../HotelInfo"));

var _HotelItinerary = _interopRequireDefault(require("../HotelItinerary"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react/no-children-prop*/
var Container = (0, _styledComponents["default"])(_pclnDesignSystem.Flex).withConfig({
  componentId: "sc-12n0vzx-0"
})(["flex-direction:column;width:100%;background-color:", ";"], (0, _pclnDesignSystem.getPaletteColor)('background.lightest'));
var HotelBookingInfo = (0, _react.memo)(function (_ref) {
  var className = _ref.className;
  return _react["default"].createElement(Container, {
    className: className,
    "data-cy": "HotelBookingInfo"
  }, _react["default"].createElement(_HotelInfo["default"], null), _react["default"].createElement(_HotelItinerary["default"], null));
});
HotelBookingInfo.displayName = 'HotelBookingInfo';
HotelBookingInfo.propTypes = {
  className: _propTypes["default"].string
};
HotelBookingInfo.defaultProps = {
  className: ''
};
var _default = HotelBookingInfo;
exports["default"] = _default;